import "../Menu.css";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const Arvind = () => {
	return (
		<>
			<Navbar />
			<Homecarousel />

			<div className="container">
				<center>
					<div>
						<h2 className="heading-p1">Mr. Arvind Pratap Singh</h2>
					</div>
					<div>
						<h6 className="heading-p2">Global G.A.P Standard Expert </h6>
					</div>
					<div>
						<img className="image" src="../images/arvind.png" alt="" />
					</div>
				</center>
			</div>
			<div className="row">
				<div className="col containerin">
					<b>Present</b>
					<br />
					<span>Technical Manager for GlobalG.A.P Scheme</span>
					<br />
					<b>Professional Qualifications</b>
					<br />
					<span> Qualified Inspector </span>
					<br />
					<ul>
						<li>
							GlobalG.A.P Scopes for Fruits & Vegetable, Tea, Combinable Crops,
							Aquaculture
						</li>
						<li>Chain of Custody</li>
						<li>Tesco Nature</li>
						<li>GRASP</li>
						<li>LEAF Marque Certification</li>
					</ul>
					<b> Education:</b> <br />
					<span>
						{" "}
						M.Sc (Agriculture) <br />
						Agri Business Management
					</span>
					<br />
					<b>Successfully completed training:</b>{" "}
					<ul>
						<li>
							GlobalG.A.P in Latest Trainer Training Plants V6 and Group
							Certification Quality Management Systems V6
						</li>
						<li> Chain of Custody V6</li>
						<li> GRASP V2</li>
						<li> Tesco Nature Module vs II WARP</li>
					</ul>
				</div>
			</div>
			<Footer />
		</>
	);
};
export default Arvind;
